<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">A gente te explica!</h6>
    <p class="subtitle">
      Conte com o nosso time de atendimento para te auxiliar em tudo que você
      precisa saber sobre a lista de presentes:
    </p>

    <ul class="benefits-list">
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Quais as vantagens da nossa lista;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como editar a lista de presentes;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como criar presentes totalmente personalizados;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como receber os presentes em dinheiro;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        E muito mais!
      </li>
      <li>É só clicar no botão abaixo para falar com a gente ;)</li>
    </ul>

    <a
      @click="$emit('keepList')"
      href="https://ajuda.casar.com/support/solutions/articles/73000559928-como-funciona-a-lista-de-presentes-do-casar-com-"
      target="_blank"
      class="button is-primary"
    >
      Quero entender melhor a lista de presentes
    </a>
    <p>
      <a @click="$emit('disableList')" class="link" href="#"
        >Quero desativar a minha lista de presentes</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>
